import React, { useState, useEffect } from 'react';

const LOADING_DURATION_MS = 1500;

const LoadingScreen = () => {
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsLoading(false);
    }, LOADING_DURATION_MS);

    return () => clearTimeout(timer);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []); // Empty deps intentional: run once on mount

  if (!isLoading) return null;

  return (
    <div className="fixed inset-0 z-[9999] bg-slate-950 overflow-hidden">
      {/* Skeleton Header */}
      <div className="fixed top-0 left-0 right-0 h-20 bg-slate-900 border-b border-slate-800 flex items-center justify-between px-8 animate-pulse">
        <div className="h-12 w-48 bg-slate-800 rounded"></div>
        <div className="flex space-x-4">
          <div className="h-8 w-16 bg-slate-800 rounded"></div>
          <div className="h-8 w-20 bg-slate-800 rounded"></div>
          <div className="h-8 w-16 bg-slate-800 rounded"></div>
          <div className="h-8 w-24 bg-slate-800 rounded"></div>
        </div>
      </div>

      {/* Main Content */}
      <div className="pt-20 overflow-y-auto h-full">
        {/* Hero Section Skeleton */}
        <div className="min-h-screen flex flex-col items-center justify-center px-4 animate-pulse">
          {/* Logo */}
          <div className="w-64 h-64 bg-slate-800 rounded-full mb-8 shimmer"></div>
          
          {/* Title Lines */}
          <div className="w-96 h-12 bg-slate-800 rounded mb-4 shimmer"></div>
          <div className="w-80 h-8 bg-slate-800 rounded mb-8 shimmer"></div>
          
          {/* Badges */}
          <div className="flex space-x-4 mb-8">
            <div className="w-48 h-16 bg-slate-800 rounded shimmer"></div>
            <div className="w-48 h-16 bg-slate-800 rounded shimmer"></div>
          </div>

          {/* CTA Button */}
          <div className="w-40 h-12 bg-slate-800 rounded shimmer"></div>
        </div>

        {/* Services Section Skeleton */}
        <div className="max-w-7xl mx-auto px-4 py-16 animate-pulse">
          <div className="w-64 h-10 bg-slate-800 rounded mb-12 mx-auto shimmer"></div>
          
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            {[1, 2, 3, 4, 5, 6].map((i) => (
              <div key={i} className="bg-slate-800 rounded-lg p-6 h-48 shimmer"></div>
            ))}
          </div>
        </div>

        {/* Gallery Preview Skeleton */}
        <div className="max-w-7xl mx-auto px-4 py-16 animate-pulse">
          <div className="w-48 h-10 bg-slate-800 rounded mb-12 mx-auto shimmer"></div>
          
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            {[1, 2, 3].map((i) => (
              <div key={i} className="bg-slate-800 rounded-lg overflow-hidden">
                <div className="h-48 bg-slate-700 shimmer"></div>
                <div className="p-4 space-y-3">
                  <div className="h-6 bg-slate-700 rounded w-3/4 shimmer"></div>
                  <div className="h-4 bg-slate-700 rounded shimmer"></div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      <style jsx>{`
        @keyframes shimmer {
          0% {
            background-position: -1000px 0;
          }
          100% {
            background-position: 1000px 0;
          }
        }

        .shimmer {
          background: linear-gradient(
            90deg,
            rgba(30, 41, 59, 1) 0%,
            rgba(51, 65, 85, 1) 50%,
            rgba(30, 41, 59, 1) 100%
          );
          background-size: 1000px 100%;
          animation: shimmer 2s infinite;
        }
      `}</style>
    </div>
  );
};

export default LoadingScreen;
